import $ from "jquery";

let ecologi_data = false;
export default function handleEcologiData() {
    let $elements = $('.js-ecologi-data');

    if ($elements.length <= 0) {
        return;
    }

    if (ecologi_data !== false) {
        updateEcologiElements($elements, ecologi_data);
    } else {
        Ajax.get(null, 'https://public.ecologi.com/users/efxawards/impact', {}).then((data) => {
            ecologi_data = data;
            updateEcologiElements($elements, data);
        }).catch((e) => {
            console.log(e);
        });
    }
}

function updateEcologiElements($elements, data) {
    $elements.each(function () {
        let $this = $(this);
        if ('undefined' !== typeof data.trees) {
            $this.find('.js-trees').text(data.trees);
        }
        if ('undefined' !== typeof data.carbonOffset) {
            $this.find('.js-carbon-offset').text(data.carbonOffset);
        }
    });
}